import React from 'react';
import SlideLayout from '../layouts/SlideLayout';
import { ActionableSlideProps } from '../types';
import '../styles/ActionableSlide.css';

const ActionableSlide: React.FC<ActionableSlideProps> = ({
  title,
  subtitle,
  steps,
  footer
}) => {
  return (
    <SlideLayout footer={footer} className="actionable-slide">
      <div className="actionable-content">
        <h1 className="actionable-title">{title}</h1>
        {subtitle && <p className="actionable-subtitle">{subtitle}</p>}
        <div className="actionable-steps">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`actionable-step ${step.highlighted ? 'highlighted' : ''}`}
            >
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </SlideLayout>
  );
};

export default ActionableSlide;
